// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

import admin_general     from "./905-admin_general.js"     ;
import admin_crud        from "./910-admin_crud.js"        ;
import admin_multiselect from "./912-admin_multiselect.js" ;

/*

show tables;
select * from 171_related_products;
select * from 102_product where related_products_grouping_id is not null \G
select id, slug_en, related_products_grouping_id from 102_product where id = 290 ;
select id, slug_en, related_products_grouping_id from 102_product;


*/

export default {

    init()
    {
        // products overview?
        if ( $('.c-admin-related-products-groupings' ).length > 0 ){
            this.init_related_products_groupings();
        }
        // product page?
        else if ( $('.c-admin-related-products' ).length > 0 ){
            this.init_related_products();
        }
    },

    // ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  PRODUCT GROUPINGS  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_related_products_groupings()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  PRODUCT GROUPING  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_related_products()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form'          ).on( 'submit', this.on__form__submit() );
        $('.js-delete-button' ).on( 'click' , this.on__delete_button__click() );
        $('.js-tab__delete'   ).on( 'click' , this.on__delete_tab__click() );

        // update mode? ⇒ make frontend reflect g_related_products
        if ( g_mode === 'update' ){

            for ( let [ key, value ] of Object.entries( g_related_products ) ){

                // empty value? ⇒ do nothing
                if ( value === null ){
                    continue;
                }

                // we need strings from now on
                if ( typeof value !== 'string' ){
                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

            }
        }

        let products = await admin_crud.GET(  admin_crud.posturl( '102_product', 'select_all' ), {} );
        products = products.data;

        // make lookup of selected products in g_related_products
        let lookup = {};

        if ( g_related_products && g_related_products.products ){
            for ( let selected_product of g_related_products.products ){
                lookup[ selected_product.id ] = selected_product;
            }
        }

        let selected  = [];
        let available = [];

        for ( let product of products ){

            var name = product.name_nl;
            if ( product.variant_nl ){
                name += ` (${product.variant_nl})`;
            }

            // selected product?
            if ( lookup[ product.id ] ){
                selected.push({
                    'value'    : product.id ,
                    'name'     : name       ,
                    'selected' : true       ,
                    'weight'   : parseInt( lookup[ product.id ].weight ),
                });
            }
            else { // not selected
                available.push({
                    'value'    : product.id ,
                    'name'     : name       ,
                    'selected' : false      ,
                });
            }
        }

        // sort selected on weight descending
        selected.sort( ( a, b ) => {
            return a.weight - b.weight;
        } );

        available.sort( ( a, b ) => {
            return a.name.localeCompare( b.name );
        } );

        // rejoin
        products = [ ...selected, ...available ];

        // initialize the products multiselect
        this.products_multiselect = new admin_multiselect();
        this.products_multiselect.init({
            select_name   : 'products',
            wrapper_class : '.js-products-multiselect',
            data          : products,
        });

    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            // delete button clicked? ⇒ handle separately
            if ( $('.js-delete-button').data( 'delete-button-clicked' ) ){
                $('.js-delete-button').removeData( 'delete-button-clicked' );
                return this.on__form_delete__submit();
            }

            { // collect form data
                var related_products_data = {};
                var product_ids           = [];

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){

                    if ( name == 'products' ){
//                      product_ids = this.products_multiselect.selected();
                        product_ids.push( value );
                        continue;
                    }

                    related_products_data[ name ] = value;
                }
            }

            // validate_input
            let validated = this.validate_input( related_products_data );
            if ( ! validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // this will contain product-id later
            let related_products_id = false;

            // insert? ⇒ insert product data in database and get the related_products_id
            if ( g_mode === 'insert' ){

                // insert product datacfr. 910-admin-crud.js
                let response = await
                admin_crud.POST( admin_crud.posturl( '170_related_products_grouping', 'insert' ), {
                    data : related_products_data,
                } );

                related_products_id = response.data.id;
            }

            // update? ⇒ update product data in database
            if ( g_mode === 'update' ){

                // get product-id from g_related_products
                related_products_id = g_related_products.id

                let ids = {
                    'id': related_products_id
                };

                let response = await
                admin_crud.POST( admin_crud.posturl( '170_related_products_grouping', 'update' ), {
                    ids  : {
                            'id': related_products_id,
                           },
                    data : related_products_data,
                } );

            }

            // update? ⇒ clear all existing ingredients
            if ( g_mode === 'update' ){
                await this.delete_grouping_products();
            }

            // update/insert ⇒ insert product categories
            let weight = 10;
            for ( let product_id of product_ids ){

                let response = await
                admin_crud.POST( admin_crud.posturl( '171_related_products', 'insert' ), {
                    data : {
                        product_id  : product_id          ,
                        grouping_id : related_products_id ,
                        weight      : weight              ,
                    }
                } );

                weight += 30;
            }


            { // handle redirect/reload

                if ( g_mode === 'insert' ){

                    let target_url = '/admin/related-products/' + related_products_id;

                    // redirect to the edit page of the new product
                    window.location.replace( target_url );
                }
                else if ( g_mode === 'update' ){

                    // show product saved
                    $('.c-saved.c-saved--ok').show();
                    $('.c-saved.c-saved--ok').fadeOut('slow');
                }
            }

            admin_general.stop_spinning();
        };
    },

    on__delete_button__click()
    {
        return ( e ) => {
            $('.js-delete-button').data( 'delete-button-clicked', true );
        };
    },

    on__delete_tab__click()
    {
        return ( e ) => {
            e.preventDefault();

            // fake that somebody clicked on the delete button on the bottom of the page
            $('.js-delete-button').click();
        };
    },

    async on__form_delete__submit()
    {
        // are your sure?
        if ( ! confirm( 'Are you sure?' ) ){
            admin_general.stop_spinning();
            return; // user is not sure...
        }

        // some products use this grouping ⇒ remove the link in the products
        await this.reset_102_product_related_products_grouping_id();

        // delete 171_related_products records
        await this.delete_grouping_products();

        // reset in 102_product field 'related_products_grouping_id' with the id of this grouping
        await this.reset_grouping_in_products_table( g_related_products.id );

        // delete product record
        let response = await
        admin_crud.POST( admin_crud.posturl( '170_related_products_grouping', 'delete' ), {
            ids : {
                id : g_related_products.id,
            },
        } );

        // redirect to products overview
        window.location.replace( '/admin/related-products-groupings' );

        return;
    },

    validate_input( related_products_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;

        for ( let key of [ 'name'  ] ){

            if ( ! related_products_data[key] ){
                validated = false;
                $('[name="'+key+'"]').addClass( 'is-error' );
            }

        }

        return validated;
    },

    async reset_102_product_related_products_grouping_id()
    {
        // select all products
        let response = await
        admin_crud.GET( admin_crud.posturl( '102_product', 'select_all' ), {} );
        let all_products = response.data;

        for ( let p of all_products ){

            // not linked in this product? ⇒ do nothing
            if ( p.related_products_grouping_id != g_related_products.id ){
                continue;
            }

            // update 102_product.related_products_grouping_id
            let response = await
            admin_crud.POST( admin_crud.posturl( '102_product', 'update' ), {
                ids  : { 'id': p.id },
                data : { 'related_products_grouping_id': null, },
            } );
        }
    },

    async delete_grouping_products()
    {
        if ( ! g_related_products.id ){
            return;
        }

        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '171_related_products', 'select_where' ), {
                'where' : {
                    'grouping_id': g_related_products.id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '171_related_products', 'delete' ), {
                ids : {
                    product_id  : r.product_id,
                    grouping_id : g_related_products.id,
                },
            } );
        }

    },

    //× reset the grouping in products that are using this grouping

    async reset_grouping_in_products_table( grouping_id )
    {
        // load records to update
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '102_product', 'select_where' ), {
                'where' : {
                    'related_products_grouping_id': grouping_id,
                }
            } );
            return response.data;
        })();

        // update records
        for ( let r of records ){

            let response = await
            admin_crud.POST( admin_crud.posturl( '102_product', 'update' ), {
                ids  : {
                           id : r.id,
                       },
                data : {
                           related_products_grouping_id : null,
                       },
            } );
        }
    },

}

